/* Component Dependencies */
var linksAndDocumentsTemplate = require('templates/linksAndDocuments.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'linksAndDocuments',
  template: {
    'linksAndDocuments': linksAndDocumentsTemplate
  }
});
